// src/components/Admin/SalasCmp/UserFreeSalasItemSalas.jsx
import React from "react";
import { Button, Card, Image, Icon } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import "./UserFreeSalasItemSalas.scss";

export function UserFreeSalasItemSalas({ scene }) {
  const navigate = useNavigate();

  const handleInfoClick = () => {
    navigate(`/userfree/guia/${scene.refId}`);
  };

  return (
    <Card className="scene-card">
      <Image src={scene.bannertopUrl} wrapped ui={false} />
      <Card.Content className="content">
        <Card.Header className="header">{scene.title}</Card.Header>
        <Card.Meta className="meta">
          {scene.subcategory?.map((sub, index) => (
            <span key={index} className="subcategory">
              {sub}
            </span>
          ))}
        </Card.Meta>
      </Card.Content>
      <Card.Content extra className="actions">
        <Button primary size="small" as="a" href={scene.urlsala} target="_blank">
          Entrar
        </Button>
        <Button secondary size="small" onClick={handleInfoClick}>
          <Icon name="info circle" />
        </Button>
      </Card.Content>
    </Card>
  );
}
